<template>
  <div>
    <b-sidebar
      id="sidebar-filter"
      v-model="showSlide"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      aria-labelledby="sidebar-filter-title"
      @hidden="hide()"
      no-header
    >
      <template>
        <div>
          <div class="p-2 d-flex justify-content-between align-items-center">
            <label class="header-text">กรองข้อมูล</label>
            <label class="pointer" @click="hide"
              ><b-icon icon="x-circle-fill"></b-icon
            ></label>
          </div>
          <div>
            <div class="p-2">
              <InputText
                textFloat="หมายเลขสมาชิก (Member ID)"
                v-model="filter.memberId"
                class="mb-2"
                placeholder="Member ID"
                type="text"
              />
              <InputText
                textFloat="ชื่อสมาชิก (Member Name)"
                v-model="filter.name"
                class="mb-2"
                placeholder="Name"
                type="text"
              />
              <InputText
                textFloat="หมายเลขโทรศัพท์ (Phone No.)"
                v-model="filter.telephone"
                class="mb-2"
                placeholder="Phone No."
                type="text"
              />
              <InputText
                textFloat="หมายเลขใบเสร็จ (POS Ref No.)"
                v-model="filter.invoiceNo"
                class="mb-2"
                placeholder="POS Ref No."
                type="text"
              />
              <div class="mb-2">
                <div class="header-text">วันที่เริ่มต้น</div>
                <div :class="['input-container']">
                  <datetime
                    :input-style="styleDatetime"
                    v-model="filter.startDate"
                    placeholder="DD/MM/YYYY"
                    @close="changeStartDate"
                    ref="startDate"
                  >
                  </datetime>
                  <div
                    class="icon-container text-right"
                    @click="$refs.startDate.isOpen = true"
                  >
                    <font-awesome-icon icon="calendar-alt" class="text-main" />
                  </div>
                </div>
              </div>
              <div class="mb-2">
                <div class="header-text">วันที่สิ้นสุด</div>
                <div :class="['input-container']">
                  <datetime
                    :input-style="styleDatetime"
                    v-model="filter.endDate"
                    placeholder="DD/MM/YYYY"
                    :min-datetime="filter.startDate"
                    @close="onChangeEndDate"
                    ref="endDate"
                  >
                  </datetime>
                  <div
                    class="icon-container text-right"
                    @click="$refs.endDate.isOpen = true"
                  >
                    <font-awesome-icon icon="calendar-alt" class="text-main" />
                  </div>
                </div>
              </div>
              <InputText
                textFloat="รหัสพนักงาน (Saleperson ID)"
                v-model="filter.saleId"
                class="mb-2"
                placeholder="Saleperson ID"
                type="text"
              />
              <div>
                <div class="header-text">สถานะการซื้อ (Order status)</div>
                <b-form-select
                  class="input-container"
                  v-model="filter.status"
                  :options="transactionOption"
                ></b-form-select>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="text-center p-2">
          <p @click="clearFilter"><u>ล้างตัวกรอง</u></p>
          <b-button class="radius-btn bg-main" block @click="submitForm"
            ><span>ค้นหา</span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
export default {
  name: "SlideFilter",
  components: { InputText },
  props: {
    filter: {
      type: Object,
      isRequired: true,
    },
  },
  data() {
    return {
      showSlide: false,
      transactionOption: [
        {
          text: "All",
          value: "0",
        },
        {
          text: "Completed",
          value: "1",
        },
        {
          text: "Void",
          value: "2",
        },
        {
          text: "Returned",
          value: "3",
        },
      ],
      styleDatetime: {
        width: "100%",
        border: "none",
      },
    };
  },
  methods: {
    show() {
      this.showSlide = true;
    },
    hide() {
      this.showSlide = false;
    },
    changeStartDate() {
      if (!this.filter.endDate) {
        this.filter.endDate = this.filter.startDate;
      }
      if (this.filter.startDate >= this.filter.endDate) {
        this.filter.endDate = this.$moment(this.filter.startDate)
          .add("day", 0)
          .format();
      }
    },
    onChangeEndDate() {
      if (!this.filter.startDate) {
        this.filter.startDate = this.filter.endDate;
      }
      const year = [1, 2, 3, 4, 5, 6, 7];
      const dataset = [
        {
          label: "Lazada",
          data: [65, 59, 80, 81, 56, 55, 40],
        },
        {
          label: "Shopee",
          data: [65, 59, 80, 81, 56, 55, 40],
        },
        {
          label: "CRM",
          data: [65, 59, 80, 81, 56, 55, 40],
        },
      ];
    },
    async clearFilter() {
      this.filter.memberId = "";
      this.filter.name = "";
      this.filter.telephone = "";
      this.filter.invoiceNo = "";
      this.filter.startDate = "";
      this.filter.endDate = "";
      this.filter.saleId = "";
      this.filter.status = "0";
      this.filter.page = 1;
      this.filter.perPage = 8;
      this.$emit("onSubmitFilter");
    },
    async submitForm() {
      await this.$emit("onSubmitFilter");
      this.hide();
    },
  },
};
</script>

<style scoped>
.input-container {
  display: flex;
  height: 100%;
  padding: 0.5rem;
  background-color: white;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
}
</style>
